import styled from 'styled-components';
export const PopoverContainer = styled.div `
  visibility: hidden;
  pointer-events: none;

  &[data-popper-reference-hidden='false'] {
    visibility: visible;
    pointer-events: initial;
  }
`;
